import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Interactable from '../../Component/Interactable';
import AnimationComponent from '../../Component/Animation';
import Point from '../../Utility/Point';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';
import ChestComponent from '../../Component/World/Chest';

const DEG2RAD: number = Math.PI / 180;

export default class Chest extends GameObject {
    protected onCreate(params: {
        x: number;
        y: number;
        chestNumber: number;
        requiredStars: number;
        totalStars: number;
    }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);
        this.addComponent<ChestComponent>(ChestComponent, params);
        this.addComponent<Interactable>(Interactable, {
            enabled: true,
            buttonMode: true,
        });

        const enoughStars: boolean = params.totalStars > params.requiredStars;

        // Add the shadow sprite.
        const shadowSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: 'shadowSprite',
            texture: 'chest_close',
            anchor: new Point(0.5, 1),
            tint: 0,
            alpha: 0.2,
        });
        const shadowTransform: TransformComponent = shadowSprite.getComponent(
            TransformComponent
        );
        shadowTransform.x = 10;
        shadowTransform.scale.set(1, 0.5);
        shadowTransform.rotation = 7 * DEG2RAD;

        shadowSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: enoughStars ? 'ChestShadowJump' : 'ChestIdle',
        });

        this.addChild(shadowSprite);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: 'chestSprite',
            texture: 'chest_close',
            anchor: new Point(0.5, 1),
        });

        baseSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: enoughStars ? 'ChestJump' : 'ChestIdle',
        });

        this.addChild(baseSprite);

        // Add the speech bubble.
        const msg: Array<string | number> = [
            Game.locale.getText('MoreStars'),
            ' ',
            params.totalStars,
            '/',
            params.requiredStars,
        ];

        const speechBubble: SpeechBubble = GameObject.Instantiate(
            SpeechBubble,
            {
                name: 'speechBubble',
                x: 0,
                y: -120,
                text: msg.join(''),
                textStyle: Game.style.getStyle('chest.text'),
                visible: false,
            }
        );
        this.addChild(speechBubble);
    }
}
